import { ReactComponent as PlusIcon } from "../../../../assets/img/icons/plus.svg";
import { useTranslation } from "react-i18next";

export default function AddItemButton({ onClick, className }) {
  const { t } = useTranslation();
  return (
    <button className={`${className} flex flex-row gap-x-1`} onClick={onClick}>
      <PlusIcon className="self-center w-6 h-6" />
      <span className="text-base self-center">{t("registrationsPage.actions.add")}</span>
    </button>
  );
}
